import api from "./api";

export const getCompanyExpiryStatus = () => {
  return api.get("/companies/expiry-status");
};

export const getCompanySetting = (settingKey) => {
  return api.get(`/settings/${settingKey}`);
};

export const updateCompanySetting = (settingKey, value) => {
  return api.put(`/settings/${settingKey}`, { value });
};